export const toContacts = contacts => contacts.map(toContact)

export const toContact = contact => ({
  value: contact.id,
  label: contact.name,
  system: contact.system
})
